import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';

import { FormControl, RadioGroup, Radio, Box, Typography } from '@material-ui/core';
import Insurer from '../model/insurer';
import { validate } from 'class-validator';
import { Alert, AlertTitle } from '@material-ui/lab';


interface InsurerProps {
    disabled: boolean | undefined;
    onDataChange: any;
    data: Insurer;
    renderButtons: any;
    nextClick: any;
    prevClick: any;
}

export class InsurerForm extends Component<InsurerProps, any> {

    constructor(props: InsurerProps) {
        super(props);
        this.state = { 
            form: props.data,
            errors: [],
            disabled: this.props.disabled 
        };
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleChange = (event: any) => {
        if (event.target.name === "postalAddressSameAsAddress") {
            this.setState({
                form: Object.assign(this.state.form,
                    { [event.target.name]: event.target.value === "true" }
                )
            });
        } else if (event.target.name === "type") {
            this.setState({
                form: Object.assign(this.state.form,
                    { [event.target.name]: parseInt(event.target.value) }
                )
            });
        } else {
            this.setState({ 
                form: Object.assign(this.state.form,
                    { [event.target.name]: event.target.value }
                )
            });
        }
    }

    handleAddressChange = (event: any) => {

        var insurer = this.state.form;
        Object.assign(insurer.address,
            { [event.target.name]: event.target.value }
        )
        this.setState({ 
            form: insurer
        });        
    }

    handlePostalAddressChange = (event: any) => {

        var insurer = this.state.form;
        Object.assign(insurer.postalAddress,
            { [event.target.name]: event.target.value }
        )
        this.setState({ 
            form: insurer
        });        
    }

    handleSelectChange = (event: any) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    validateForm = async() : Promise<boolean> => {

        const state = this.state.form;
        const errors = await validate(state);

        this.setState({
            errors: errors.map((element)=> {
                if (element.children.length === 0)
                    return element.property;
                else
                    return element.children.map((child)=> {return element.property + '.' + child.property})
            }).flat()
        });

        return errors.length === 0;
    }

    getData = () : Insurer => {
        return this.state.form;
    }

    hasError = (fieldName: string) : boolean => {
        return this.state.errors.includes(fieldName)
    }

    next = async() => {
        let result = await this.validateForm();
        if (result) {
            this.props.onDataChange(this.getData());
            this.props.nextClick();
        } else {
            window.scrollTo(0, 0);
        }
    }

    previous = () => {
        this.props.onDataChange(this.getData());
        this.props.prevClick();
    }

    render() {

        return (
            <Fragment>
                <Box marginBottom={3}>
                    <Typography variant="h5" align="center" gutterBottom={true}>Ubezpieczający</Typography> 
                </Box>
                {
                    this.state.errors.length > 0 ?
                    <>
                        <Alert severity="error">
                            <AlertTitle>Uwaga</AlertTitle>
                            <p>Pola zaznaczone na czerwono są obowiązkowe. Wypełnij je, aby przejść dalej.</p>
                        </Alert>
                        <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                    </>
                    : null
                        
                }
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <RadioGroup row name="type" value={this.state.form.type} onChange={this.handleChange}>
                                <FormControlLabel value={1} control={<Radio disabled={this.props.disabled} />} label="Osoba fizyczna" />
                                <FormControlLabel value={2} control={<Radio disabled={this.props.disabled} />} label="Przedsiębiorca" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    {this.state.form.type === 1 ? this.renderPerson() : null }
                    {this.state.form.type === 2 ? this.renderCompany() : null }
                   
                    {this.state.form.type ? this.renderCommonProperties() : null }

                    {this.state.form.type === 1 ? this.renderPESEL() : null }
                    {this.state.form.type === 2 ? this.renderRegon() : null }

                </Grid>
                {this.state.form.type ? ( 
                    <Grid container spacing={2}>
                        <Grid alignItems="center" container item xs={12} sm={7}>
                                <FormControl>
                                Czy adres korespondencyjny jest taki sam jak ubezpieczającego?
                                </FormControl>
                       
                        </Grid>
                        <Grid alignItems="center" container item xs={12} sm={5}>
                            <RadioGroup row name="postalAddressSameAsAddress" value={this.state.form.postalAddressSameAsAddress} onChange={this.handleChange}>
                                <FormControlLabel value={true} control={<Radio disabled={this.props.disabled}/>} label="Tak" />
                                <FormControlLabel value={false} control={<Radio disabled={this.props.disabled}/>} label="Nie" />
                            </RadioGroup>
                        </Grid>
                        {!this.state.form.postalAddressSameAsAddress ? this.renderPostalAddress() : null}
                    </Grid>
                ) : null }
                {/* </Paper> */}
                {this.props.renderButtons({ caption: 'Dalej', click: this.next }, { caption: 'Wstecz', click: this.previous })}
            </Fragment>
        )
    }

    renderPerson = () => {
        return (
            <Fragment>
                <Grid item xs={12} sm={6}>
                    <TextField error={this.hasError("firstName")} disabled={this.props.disabled} id="firstName" label="Imię" name="firstName"
                        value={this.state.form.firstName} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField error={this.hasError("lastName")} disabled={this.props.disabled} id="lastName" label="Nazwisko" name="lastName"
                        value={this.state.form.lastName} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                    />
                </Grid>
            </Fragment>
        )
    }

    renderCompany = () => {
        return (
            <Fragment>
                <Grid item xs={12} sm={12}>
                <TextField error={this.hasError("companyName")} disabled={this.props.disabled} id="companyName" label="Nazwa podmiotu" name="companyName"
                    value={this.state.form.companyName} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                />
                </Grid>
            </Fragment>
        )
    }

    renderPESEL = () => {
        return (
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("PESEL")} disabled={this.props.disabled} id="PESEL" label="PESEL" name="PESEL"
                    value={this.state.form.PESEL} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                />
            </Grid>
        )    
    }

    renderRegon = () => {
        return (
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("REGON")} disabled={this.props.disabled} id="REGON" label="Regon" name="REGON"
                    value={this.state.form.REGON} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                />
            </Grid>
        )
    }

    renderCommonProperties = () => {
        return (
        <Fragment>
             <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("address.cityName")} disabled={this.props.disabled} id="cityName" label="Miejscowość" name="cityName"
                    value={this.state.form.address.cityName} variant="outlined" margin="normal" required fullWidth onChange={this.handleAddressChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("address.postalCode")} disabled={this.props.disabled} id="postalCode" label="Kod pocztowy" name="postalCode"
                    value={this.state.form.address.postalCode} variant="outlined" margin="normal" required fullWidth onChange={this.handleAddressChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("address.streetName")} disabled={this.props.disabled} id="streetName" label="Ulica" name="streetName"
                    value={this.state.form.address.streetName} variant="outlined" margin="normal" fullWidth onChange={this.handleAddressChange}
                />
            </Grid>
            <Grid item xs={6} sm={3}>
                <TextField error={this.hasError("address.streetNumber")} disabled={this.props.disabled} id="streetNumber" label="Nr domu" name="streetNumber"
                    value={this.state.form.address.streetNumber} variant="outlined" margin="normal" required fullWidth onChange={this.handleAddressChange}
                />
            </Grid>
            <Grid item xs={6} sm={3}>
                <TextField error={this.hasError("address.apartmentNumber")} disabled={this.props.disabled} id="apartmentNumber" label="Nr lokalu" name="apartmentNumber"
                    value={this.state.form.address.apartmentNumber} variant="outlined" margin="normal" fullWidth onChange={this.handleAddressChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("phoneNumber")} disabled={this.props.disabled} id="phoneNumber" label="Nr telefonu" name="phoneNumber"
                    value={this.state.form.phoneNumber} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField error={this.hasError("email")} disabled={this.props.disabled} id="email" label="Adres email" name="email"
                    value={this.state.form.email} variant="outlined" margin="normal" required fullWidth autoComplete="email" onChange={this.handleChange}
                />
            </Grid>
        </Fragment>
        )
    }

    renderPostalAddress = () => {
        return (
            <Fragment>
            {/*Adres do korespondencji*/}
            <Grid item xs={12} sm={12}>
              <TextField error={this.hasError("postalAddress.addressee")} disabled={this.props.disabled} id="postalAddress.addressee" label="Adresat" name="addressee"
                value={this.state.form.postalAddress.addressee} variant="outlined" margin="normal" required fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>
    
            <Grid item xs={12} sm={6}>
              <TextField error={this.hasError("postalAddress.cityName")} disabled={this.props.disabled} id="postalAddress.cityName" label="Miejscowość" name="cityName"
                value={this.state.form.postalAddress.cityName} variant="outlined" margin="normal" required fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField error={this.hasError("postalAddress.postalCode")} disabled={this.props.disabled} id="postalAddress.postalCode" label="Kod pocztowy" name="postalCode"
                value={this.state.form.postalAddress.postalCode} variant="outlined" margin="normal" required fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>
    
            <Grid item xs={12} sm={6}>
              <TextField error={this.hasError("postalAddress.streetName")} disabled={this.props.disabled} id="postalAddress.streetName" label="Ulica" name="streetName"
                value={this.state.form.postalAddress.streetName} variant="outlined" margin="normal" fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField error={this.hasError("postalAddress.streetNumber")} disabled={this.props.disabled} id="postalAddress.streetNumber" label="Nr domu" name="streetNumber"
                value={this.state.form.postalAddress.streetNumber} variant="outlined" margin="normal" required fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField error={this.hasError("postalAddress.apartmentNumber")} disabled={this.props.disabled} id="postalAddress.apartmentNumber" label="Nr lokalu" name="apartmentNumber"
                value={this.state.form.postalAddress.apartmentNumber} variant="outlined" margin="normal" fullWidth onChange={this.handlePostalAddressChange}
              />
            </Grid>      
          </Fragment>
        )
    }
}
